(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lightcad-bike-finder"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lightcad-managed-finder')) {
  class LightCadManagedFinder extends HTMLElement {
    connectedCallback() { requestAnimationFrame(() => this.init()); }
    disconnectedCallback() { this.controller?.abort(); }
    read(selector, fallback, root = this) {
      const node = root.querySelector(selector);
      return node ? JSON.parse(node.textContent) : fallback;
    }
    text(key, values = {}) {
      return Object.entries(values).reduce((text, [name, value]) => text.replaceAll('[' + name + ']', String(value)), this.labels[key] || '');
    }
    async pages(selector) {
      let data = this.read(selector, { items: [], next: null });
      const items = [...data.items], seen = new Set();
      while (data.next) {
        const url = new URL(data.next, location.href);
        if (url.origin !== location.origin || seen.has(url.href)) throw new Error('Invalid pagination');
        seen.add(url.href);
        url.searchParams.set('section_id', this.dataset.section);
        const preview = new URL(location.href).searchParams.get('preview_theme_id') || (window.Shopify?.theme?.role === 'unpublished' ? String(window.Shopify.theme.id) : '');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        const response = await fetch(url, { signal: this.controller.signal });
        if (!response.ok) throw new Error('Pagination failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        data = this.read(selector, null, doc);
        if (!data || !Array.isArray(data.items)) throw new Error('Missing page');
        items.push(...data.items);
      }
      return items;
    }
    async init() {
      if (this.initialized || !this.isConnected) return;
      this.initialized = true;
      this.controller = new AbortController();
      this.labels = this.read('[data-lc-labels]', {});
      this.form = this.querySelector('.lc-form');
      this.make = this.form.elements.make;
      this.model = this.form.elements.model;
      this.year = this.form.elements.year;
      this.submit = this.querySelector('.lc-search');
      this.result = this.querySelector('.lc-results');
      this.grid = this.querySelector('.lc-grid');
      this.photo = this.querySelector('.lc-photo');
      this.caption = this.querySelector('.lc-caption');
      this.editor = this.dataset.editor === 'true';
      this.resultsPage = this.dataset.resultsPage === 'true';
      this.searchPanel = this.querySelector('.lc-top');
      try {
        const [records, catalog] = await Promise.all([this.pages('[data-lc-models]'), this.resultsPage ? this.pages('[data-lc-catalog]') : Promise.resolve([])]);
        if (!this.isConnected) return;
        this.records = records.filter(r => !r.hidden && r.brand?.trim() && r.model?.trim() && Number(r.model.match(/\d+/)?.[0]) >= 125 && !/SX-E|MC-E|^EE\b/i.test(r.model));
        this.catalog = [...new Map(catalog.map(p => [String(p.id), p])).values()];
        if (this.resultsPage && window.Shopify?.theme?.role === 'unpublished' && this.dataset.preparedCatalog) {
          const response = await fetch(this.dataset.preparedCatalog, { signal: this.controller.signal });
          if (!response.ok) throw new Error('Prepared catalogue unavailable');
          const prepared = await response.json();
          const live = new Set(this.catalog.map(p => String(p.id)));
          (prepared.items || []).forEach(p => { if (!live.has(String(p.id))) this.catalog.push(p); });
        }
        const snapshot = this.read('[data-lc-draft-snapshot]', null);
        if (this.editor && snapshot) {
          const live = new Set(this.catalog.map(p => String(p.id)));
          snapshot.p.forEach(r => {
            if (!live.has(r[0])) this.catalog.push({ id: r[0], handle: r[1], title: r[2], price: r[3], image: r[4], options: r[5].map(i => snapshot.s[i]), combinations: r[6].map(c => c.map(i => snapshot.s[i])), draft: true, tags: r[7] || [] });
          });
        }
        this.querySelector('.lc-preview').hidden = !this.catalog.some(p => p.draft);
        this.ktmRows = this.read('[data-lc-ktm-fitment]', []);
        this.modelYearCatalog = this.read('[data-lc-model-year-catalog]', {});
        this.index = new Map();
        this.records.forEach(r => this.add(r.brand.trim(), r.model.trim(), this.modelYears(r.years), null));
        this.products = new Map(this.catalog.map(p => [String(p.id), p]));
        this.catalog.forEach(p => this.indexProduct(p));
        this.fill(this.make, [...this.index.keys()].sort(), this.text('select_brand'));
        this.setPhoto('', '');
        this.querySelector('.lc-help').textContent = this.text(this.index.size ? 'help' : 'no_models');
        this.make.addEventListener('change', () => {
          this.hideResults();
          this.fill(this.model, [...(this.index.get(this.make.value)?.keys() || [])].sort((a,b) => a.localeCompare(b, undefined, {numeric: true})), this.text('select_model'));
          this.fill(this.year, [], this.text('select_year'));
          this.setPhoto(this.make.value, '');
          this.update();
        });
        this.model.addEventListener('change', () => {
          this.hideResults();
          this.fill(this.year, [...(this.index.get(this.make.value)?.get(this.model.value)?.keys() || [])].sort((a,b) => b-a), this.text('select_year'));
          this.setPhoto(this.make.value, this.model.value);
          this.update();
        });
        this.year.addEventListener('change', () => { this.hideResults(); this.setPhoto(this.make.value, this.model.value); this.update(); });
        this.form.addEventListener('submit', e => { e.preventDefault(); if (!this.submit.disabled) this.navigate(this.selectionUrl()); });
        this.querySelector('.lc-reset')?.addEventListener('click', () => { this.hideResults(); this.searchPanel.hidden = false; this.make.focus(); this.scrollIntoView({behavior:'smooth', block:'start'}); });
        this.photo.addEventListener('error', () => { this.photo.hidden = true; this.querySelector('.lc-no-photo').hidden = false; this.caption.replaceChildren(); });
        const selected = this.restoreSelection();
        this.update();
        if (this.resultsPage && selected) this.showResults(false);
        this.dataset.ready = 'true';
      } catch (error) {
        if (error.name === 'AbortError') { this.initialized = false; return; }
        this.querySelector('.lc-help').textContent = this.text('load_error');
        this.make.disabled = this.model.disabled = this.year.disabled = this.submit.disabled = true;
        this.dataset.ready = 'error';
      }
    }
    selectionUrl() {
      const url = new URL(this.dataset.resultsUrl, location.origin);
      url.searchParams.set('lc_brand', this.make.value);
      url.searchParams.set('lc_model', this.model.value);
      url.searchParams.set('lc_year', this.year.value);
      const preview = new URL(location.href).searchParams.get('preview_theme_id') || (window.Shopify?.theme?.role === 'unpublished' ? String(window.Shopify.theme.id) : '');
      if (/^\d+$/.test(preview)) url.searchParams.set('preview_theme_id', preview);
      return url.href;
    }
    navigate(url) { window.location.assign(url); }
    restoreSelection() {
      const params = new URLSearchParams(location.search);
      const brand = params.get('lc_brand'), rawModel = params.get('lc_model'), year = params.get('lc_year');
      if (!this.index.has(brand)) return false;
      this.make.value = brand;
      this.make.dispatchEvent(new Event('change'));
      const model = this.index.get(brand).has(rawModel) ? rawModel : this.models(rawModel, brand)[0];
      if (!model || !this.index.get(brand).has(model)) return false;
      this.model.value = model;
      this.model.dispatchEvent(new Event('change'));
      if (!/^\d{4}$/.test(year || '') || !this.index.get(brand).get(model).has(Number(year))) return false;
      this.year.value = year;
      this.year.dispatchEvent(new Event('change'));
      return true;
    }
    fill(select, values, label) {
      select.replaceChildren(new Option(label, ''));
      values.forEach(v => select.add(new Option(String(v), String(v))));
      select.disabled = values.length === 0;
    }
    norm(value) { return String(value || '').toUpperCase().replace(/[\s-]/g, ''); }
    models(raw, brand) {
      const key = this.norm(raw);
      const aliases = {
        Yamaha: {'YZ125/250':['YZ125','YZ250'], 'YZF250/450':['YZ250F','YZ450F']},
        Fantic: {'XX125/250':['XX 125','XX 250'], 'XXF250/450':['XXF 250','XXF 450']},
        Honda: {'CR125/250':['CR125','CR250'], 'CR125/250/500':['CR125','CR250','CR500'], 'CR125R':['CR125'], 'CR250R':['CR250'], 'CR500R':['CR500'], 'CRF250':['CRF250R'], 'CRF450':['CRF450R']},
        Kawasaki: {'KX125/250':['KX125','KX250 (2-stroke)'], 'KX250':['KX250 (2-stroke)'], 'KXF250':['KX250F','KX250 (4-stroke)'], 'KX250F':['KX250F','KX250 (4-stroke)'], 'KXF450':['KX450F','KX450 (4-stroke)'], 'KX450F':['KX450F','KX450 (4-stroke)']},
        Suzuki: {'RM125/250':['RM125','RM250']}
      };
      const keys = (aliases[brand]?.[key] || [raw]).map(v => this.norm(v));
      return [...new Set(this.records.filter(r => r.brand.trim() === brand && [r.model, ...(r.aliases || '').split(/\r?\n/)].some(v => keys.includes(this.norm(v)))).map(r => r.model.trim()))];
    }
    modelYears(raw) {
      const years = new Set();
      String(raw || '').replace(/[–—]/g, '-').split(/[,;\n]+/).forEach(part => {
        const match = part.trim().match(/^(\d{4})(?:\s*-\s*(\d{4}))?$/);
        if (!match) return;
        const first = Number(match[1]), last = Number(match[2] || match[1]);
        if (first < 1900 || last > 2199 || last < first) return;
        for (let year = first; year <= last; year++) years.add(year);
      });
      return [...years];
    }
    years(raw) {
      const s = String(raw || '').trim().replace(/[–—]/g,'-'), now = new Date().getFullYear();
      let a, b, m;
      if (/^\d{4}$/.test(s)) a = b = Number(s);
      else if ((m = s.match(/^(\d{4})-(\d{4})$/))) { a = +m[1]; b = +m[2]; if (b > now + 1) return []; }
      else if ((m = s.match(/^(\d{4})\+$/))) { a = +m[1]; b = now; }
      else return [];
      if (a < 1950 || b < a || b-a > 80) return [];
      return Array.from({length: Math.max(0, Math.min(b, now+1)-a+1)}, (_,i) => a+i);
    }
    add(brand, model, years, id) {
      if (!years.length) return;
      if (id != null) { const rows = this.index.get(brand)?.get(model); years.forEach(y => rows?.get(y)?.add(String(id))); return; }
      if (!this.index.has(brand)) this.index.set(brand, new Map());
      const models = this.index.get(brand);
      if (!models.has(model)) models.set(model, new Map());
      const rows = models.get(model);
      years.forEach(y => { if (!rows.has(y)) rows.set(y, new Set()); });
    }
    indexProduct(p) {
      if (p.fitment?.brand && Array.isArray(p.fitment.models)) {
        p.fitment.models.forEach(row => this.add(p.fitment.brand, row.model, row.years.map(Number), p.id));
        return;
      }
      if (p.handle === 'ktm-plastic-screws') {
        this.records.filter(row => row.brand === 'KTM').forEach(row => this.add('KTM', row.model, this.modelYears(row.years), p.id));
        return;
      }
      const native = this.modelYearCatalog?.[String(p.id)];
      if (native) {
        Object.entries(native.models).forEach(([model, years]) => this.add(native.brands[model], model, years.filter(year => /^\d{4}$/.test(year)).map(Number), p.id));
        return;
      }
      if ((p.tags || []).includes('lc-ktm-custom')) {
        const group = p.tags.includes('lc-ktm-enduro') ? 'enduro' : 'cross', kit = (p.tags.find(t => t.startsWith('lc-kit-')) || '').slice(7);
        this.ktmRows.filter(r => r[2] === group).forEach(r => {
          const years = kit === 'seat' ? r[3] : r[1].filter(y => kit !== 'factory' || y >= 2008);
          this.models(r[0], 'KTM').forEach(model => this.add('KTM', model, years, p.id));
        });
        return;
      }
      const brand = [...this.index.keys()].find(b => String(p.title).toLowerCase().startsWith(b.toLowerCase() + ' '));
      if (!brand) return;
      const names = (p.options || []).map(s => s.toLowerCase().trim()), mi = names.findIndex(n => n === 'bike' || n === 'model'), yi = names.indexOf('year'), ci = names.indexOf('model and year');
      (p.combinations || []).forEach(c => {
        let model, year;
        if (ci >= 0) { const pair = String(c[ci]).split(' · '); if (pair.length !== 2) return; [model, year] = pair; }
        else if (mi >= 0 && yi >= 0) { model = c[mi]; year = c[yi]; }
        else return;
        if (brand === 'Yamaha' && /YZ.?F250\/450/i.test(model) && String(year) === '1981-1985') return;
        this.models(model, brand).forEach(m => this.add(brand, m, this.years(year), p.id));
      });
      if (String(p.id) === '14782907547979') this.models('RM250','Suzuki').forEach(m => this.add('Suzuki',m,this.years('1996-2007'),p.id));
      if (String(p.id) === '14782921605451') this.models('RM250','Suzuki').forEach(m => this.add('Suzuki',m,this.years('2003-2007'),p.id));
    }
    setPhoto(brand, model) {
      const empty = this.querySelector('.lc-no-photo');
      const record = this.records.find(r => r.brand.trim() === brand && r.model.trim() === model);
      const defaultPhoto = this.read('[data-lc-default-photo]', {});
      const brandPhotos = this.records.filter(r => r.brand.trim() === brand && r.image);
      const brandPhoto = brandPhotos.find(r => /motorcross|motocross/i.test(r.category || '') && /450/.test(r.model)) || brandPhotos[0];
      const photo = model ? record : (brand ? brandPhoto : defaultPhoto);
      this.caption.replaceChildren();
      this.querySelector('.lc-photo-model').textContent = model ? brand + ' ' + model : (brand || this.text('your_motorcycle'));
      this.querySelector('.lc-no-photo span').textContent = brand ? this.text('no_photo') : this.text('select_photo');
      this.photo.hidden = !photo?.image;
      empty.hidden = !!photo?.image;
      if (!photo?.image) { this.photo.removeAttribute('src'); return; }
      this.photo.src = photo.image;
      const caption = photo.caption || [brand, model || photo.model].filter(Boolean).join(' ');
      this.photo.alt = caption || this.text('your_motorcycle');
      const yearLabel = photo.photoYear ? this.text('photo_year', {year: photo.photoYear}) : '';
      this.caption.textContent = [caption, yearLabel].filter(Boolean).join(' · ');
      if (model && photo.photoYear && this.year.value && Number(this.year.value) !== Number(photo.photoYear)) this.caption.append(document.createTextNode(' · ' + this.text('photo_differs')));
      if (photo.source && /^https:\/\//i.test(photo.source)) {
        const link = document.createElement('a'); link.href = photo.source; link.target = '_blank'; link.rel = 'noopener noreferrer'; link.textContent = this.text('photo_source');
        this.caption.append(document.createTextNode(' · '), link);
      }
    }
    update() {
      this.submit.disabled = !(this.make.value && this.model.value && this.year.value);
      this.querySelector('[data-lc-status]').textContent = this.model.value ? this.text('selected', {bike: this.make.value + ' ' + this.model.value + (this.year.value ? ' ' + this.year.value : '')}) : '';
    }
    hideResults() { if (this.result) { this.result.hidden = true; this.grid.replaceChildren(); } }
    showResults(scroll = true) {
      if (!this.resultsPage || !this.result) return;
      const ids = this.index.get(this.make.value)?.get(this.model.value)?.get(+this.year.value) || new Set();
      const products = [...ids].map(id => this.products.get(id)).filter(Boolean).sort((a,b) => a.title.localeCompare(b.title));
      this.querySelector('.lc-result-title').textContent = this.text('parts_for', {bike: this.make.value + ' ' + this.model.value + ' · ' + this.year.value});
      this.querySelector('.lc-count').textContent = this.text(products.length === 1 ? 'count_one' : 'count_many', {count: products.length});
      this.grid.replaceChildren();
      const universalProducts = ['14804161134923','14823221068107','14875799814475','15502712013131'].map(id => this.products.get(id)).filter(Boolean);
      const universalGrid = this.querySelector('.lc-universal-grid');
      universalGrid.replaceChildren();
      this.querySelector('.lc-universal').hidden = universalProducts.length === 0;
      const money = new Intl.NumberFormat(document.documentElement.lang || 'en-NL', {style:'currency', currency:this.editor ? 'EUR' : (this.dataset.currency || 'EUR')});
      [...products, ...universalProducts].forEach(p => {
        const card = document.createElement('article'); card.className = 'lc-card';
        const link = document.createElement('a');
        const record = this.records.find(r => r.brand.trim() === this.make.value && r.model.trim() === this.model.value);
        const aliases = (record?.aliases || '').split(/\r?\n/).filter(Boolean);
        let selectedModel = this.model.value;
        if ((p.tags || []).includes('lc-ktm-custom') && !(p.tags || []).includes('lc-ktm-model-year') && !(p.tags || []).includes('lc-model-year')) {
          selectedModel = this.ktmRows.find(r => (r[0] === this.model.value || aliases.includes(r[0])) && r[1].includes(+this.year.value))?.[0] || selectedModel;
        } else if (!p.fitment && !(p.tags || []).includes('lc-ktm-model-year') && !(p.tags || []).includes('lc-model-year') && aliases.length && !aliases.includes(selectedModel)) selectedModel = aliases[0];
        const params = new URLSearchParams({lc_brand:this.make.value, lc_model:selectedModel, lc_year:this.year.value});
        const preview = new URL(location.href).searchParams.get('preview_theme_id') || (window.Shopify?.theme?.role === 'unpublished' ? String(window.Shopify.theme.id) : '');
        if (/^\d+$/.test(preview)) params.set('preview_theme_id', preview);
        link.href = p.draft ? 'https://admin.shopify.com/store/q0dv0r-wj/products/' + p.id : (this.dataset.root || '/') + 'products/' + encodeURIComponent(p.handle) + '?' + params;
        if (p.draft) { link.target = '_blank'; link.rel = 'noopener'; }
        if (p.image) { const img = document.createElement('img'); img.className = 'lc-card-img'; img.src = p.image; img.alt = p.title; img.loading = 'lazy'; img.width = 400; img.height = 400; link.append(img); }
        if (p.draft) { const badge = document.createElement('span'); badge.className = 'lc-draft'; badge.textContent = this.text('draft'); card.append(badge); }
        const title = document.createElement('h4'); title.textContent = p.title; link.append(title); card.append(link);
        const price = document.createElement('p'); price.className = 'lc-price'; price.textContent = this.text('price_from', {price:money.format(Number(p.price))}); card.append(price); (universalProducts.includes(p) ? universalGrid : this.grid).append(card);
      });
      this.querySelector('.lc-empty').hidden = products.length > 0;
      this.searchPanel.hidden = true;
      this.result.hidden = false;
      if (scroll) this.result.scrollIntoView({behavior:'smooth',block:'start'});
    }
  }
  customElements.define('lightcad-managed-finder', LightCadManagedFinder);
}


  } catch(e) { console.error(e); }
})();
})();
